<script>
import '@/assets/css/papago.css'

export default {
  name: 'PapagoHeader',
}
</script>

<template>
  <div class="papago">
    <router-link to="/papago">
      <div class="logo_wrap">
        <img src="@/assets/img/papago/papago_logo.svg" />
      </div>
      <img src="@/assets/img/papago/papago_banner.png" />
    </router-link>
  </div>
</template>